import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalStateService {
  private _modalIsOpen = false;

  get modalIsOpen(): boolean {
    return this._modalIsOpen;
  }

  set modalIsOpen(value: boolean) {
    this._modalIsOpen = value;
  }
}